export const DEFAULT_FOLDER_NAMES = {
  'uploaded-video': 'Videos HTML5'
} as const;
